import * as t from "io-ts";
import { mixed } from "../../validation/validator";
import { CallResponseSchema } from "../common/callResponseSchema";

export const FirebaseChannelRecordSchema = t.type({
  name: t.string,
  url: t.string,
  expireTime: t.string,
});

export const GetFirebaseChannelsRequestSchema = t.type({
  site_id: t.string,
});

export const GetFirebaseChannelsResponseSchema = t.type({
  channels: t.array(FirebaseChannelRecordSchema),
});

export type FirebaseChannelRecord = t.TypeOf<typeof FirebaseChannelRecordSchema>;
export type GetFirebaseChannelsRequest = t.TypeOf<typeof GetFirebaseChannelsRequestSchema>;
export type GetFirebaseChannelsResponse = t.TypeOf<typeof GetFirebaseChannelsResponseSchema>;

export const AdminApis = {
  Firebase: {
    GetChannels: {
      Name: "admin-getFirebaseChannels",
      Request: GetFirebaseChannelsRequestSchema,
      Response: mixed([
        t.type({
          data: GetFirebaseChannelsResponseSchema,
        }),
        CallResponseSchema,
      ]),
    },
  },
};
